import LocationList from './LocationList';

export default {
  list: LocationList,
};
